import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

export const inputCls =
  "w-full bg-navy-950/80 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-gold-400/60 transition-colors";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-[11px] tracking-[0.2em] uppercase text-slate-500 mb-1.5">{label}</span>
    {children}
  </label>
);

export const FileField = ({ label, accept, value, onChange, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/upload", fd);
      onChange(r.data.url);
    } catch {
      alert("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <span className="block text-[11px] tracking-[0.2em] uppercase text-slate-500 mb-1.5">{label}</span>
      <div className="flex items-center gap-3">
        {value && accept.startsWith("image") && (
          <img src={mediaUrl(value)} alt="" className="w-12 h-12 rounded-md object-cover border border-gold-400/30" />
        )}
        {value && accept.startsWith("audio") && (
          <span className="text-[11px] text-gold-300 border border-gold-400/30 rounded-md px-2 py-1">MP3 attached</span>
        )}
        <button
          type="button"
          onClick={() => ref.current?.click()}
          data-testid={testid}
          className="inline-flex items-center gap-2 text-xs border border-white/15 rounded-lg px-3 py-2 text-slate-300 hover:border-gold-400/50 hover:text-gold-200 transition-colors"
        >
          <Upload size={13} /> {busy ? "Uploading…" : value ? "Replace" : "Upload"}
        </button>
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={pick} />
      </div>
    </div>
  );
};
